module.exports = "#snackMsg {\n  font-size: 14px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/gui-layout/sidebar-layout/snack-bar/snack-bar.component.scss
// module id = ./src/app/layouts/gui-layout/sidebar-layout/snack-bar/snack-bar.component.scss
// module chunks = main